import { FC } from 'react';
import { UndoMarkProps } from './UndoMark.types';
import { Flex, Card, Text, Button, ButtonGroup } from '@/_components';

export const UndoMark: FC<UndoMarkProps> = ({
  children,
  description,
  onUndo,
  isDisabled,
  value,
}) => {
  const buttonValue: string = value || 'Undo';
  return (
    <Card padding={6}>
      <Flex isColumn={true} gap={4}>
        <Text type="small">{description}</Text>
        {children}
        <ButtonGroup align="right">
          <Button
            intent="secondary"
            size="small"
            onClick={onUndo}
            value={buttonValue}
            isDisabled={isDisabled}
          />
        </ButtonGroup>
      </Flex>
    </Card>
  );
};
